import React, { FC, useCallback, useState } from "react";
import { Col, Container, Row } from "../../common/Grid";
import api from "../../../services/api";
import { useTus } from "use-tus";

type Props = {
  onUploadCompleted: () => void;
};

const UploadMediaForm: FC<Props> = ({ onUploadCompleted }) => {
  const { upload, setUpload, isSuccess, error, remove } = useTus();
  const [mediaFile, setMediaFile] = useState<File | null>(null);
  const [progress, setProgress] = useState<number | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = useCallback(async (e) => {
    setProgress(null);
    if (e.target.files) {
      const mediaFile = e.target.files[0];

      setMediaFile(e.target.files[0]);
      const { uploadLink } = await api.initUploadVideo(
        mediaFile.size,
        mediaFile.name
      );
      setUpload(mediaFile, {
        uploadUrl: uploadLink,
        endpoint: "none",
        uploadSize: mediaFile.size,
        retryDelays: [0, 1000, 3000, 5000],
        onError: (e) => console.log(e),
        onProgress: (value) => console.log(value),
        onSuccess: onUploadCompleted,
      });
    }
  }, []);

  const handleStart = useCallback(async () => {
    if (upload) {
      setIsUploading(true);
      upload.start();
    }
  }, [upload]);

  return (
    <Container pb={"20px"}>
      <Row mt="10px">
        <Col noGutter>
          <input type="file" onChange={handleFileChange} />
          <button type="button" onClick={handleStart} disabled={isUploading}>
            Upload
          </button>
          {progress && mediaFile && (
            <div>
              {progress}/{mediaFile.size}
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default UploadMediaForm;
